import {gql} from "@apollo/client"


export const GET_ALL_FAVORITES = gql`
    query get_all_favorites {
        getAllFavorites {
            id
            video {
                id
            }
        }
    }
`

export const GET_VIDEOS = gql`
    query get_videos($pageNum: Int, $perPage: Int, $categories: String, $techniques: String, $instructors: String, $q: String, $created: String) {
        videoSearch(pageNum: $pageNum, perPage: $perPage, categories: $categories,techniques: $techniques, instructors: $instructors, q: $q, created: $created) {
            page
            pages
            hasNext
            hasPrev
            objects {
                title
                id
                classType
                summary
                equipment
                largeImage {
                    rendition(width: 960) {
                        id
                        url
                    }
                }
                videoCategory {
                    node {
                        id
                        name
                        machineName
                    }
                }
                techniqueCategory {
                    node {
                        id
                        name
                        machineName
                    }
                }
                videoInstructor {
                    node {
                        id
                        name
                    }
                }
            }
        }
    }
`
